<template>
    <div class="tab-info td-fcc td-fc">
        <div style="font-weight: bold">
            <div>名称</div>
            <div>内容</div>
        </div>
        <div v-for="(item,index) in infoField" :key="index">
            <div>{{item.name}}</div>
            <div>{{studentInfo[item.field] || '未填写'}}</div>
        </div>
    </div>
</template>

<script>
    import Lockr from 'lockr'
    import {parentStudentDetail} from "@/api/parent";
    import {mapGetters, mapMutations} from 'vuex'

    export default {
        name: "learnerInfo",
        data() {
            return {
                studentId: '',//学生id
                studentInfo: '',//学生信息
                infoField: [
                    {
                        field: "emp_no",
                        name: "账号"
                    },
                    {
                        field: "realname",
                        name: "真实姓名"
                    },
                    {
                        field: "integral",
                        name: "武力值"
                    },
                    {
                        field: "sex_text",
                        name: "性别"
                    },
                    {
                        field: "age",
                        name: "年龄"
                    },
                    {
                        field: "mobile",
                        name: "手机号"
                    },
                    {
                        field: "email",
                        name: "邮箱地址"
                    },
                    {
                        field: "qq",
                        name: "QQ号码"
                    },
                    {
                        field: "wx_code",
                        name: "微信号"
                    },
                    {
                        field: "register_time",
                        name: "注册时间"
                    },
                    {
                        field: "last_login_time",
                        name: "上次登录时间"
                    },
                    {
                        field: "login_num",
                        name: "总登录次数"
                    }
                ]
            };
        },
        watch: {
            $route() {
                this.studentId = this.$route.query.student_id
                this.getStudentInfo()
            },
        },
        methods: {
            ...mapMutations(['SET_STUDENT_USERINFO']),
            getStudentInfo() {
                let params = {
                    token: Lockr.get('parentToken'),
                    student_id: this.studentId
                }
                parentStudentDetail(params).then(result => {
                    if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                        this.studentInfo = result.data
                        this.studentInfo.student_id = this.studentId
                        this.SET_STUDENT_USERINFO(result.data)
                    } else {
                        this.studentInfo = ''
                        this.$alert(result.msg, '温馨提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                            }
                        });
                    }
                })
            },
        },
        created() {
            this.studentId = this.$route.query.student_id
            this.getStudentInfo()
        },
    }
</script>

<style scoped lang='less'>
    .tab-info {
        padding: 20px 0;
        background: #fff;
        border: 1px solid #dcdcdc;

        > div {
            width: 600px;
            display: flex;
            border-left: 1px solid #dcdcdc;
            border-top: 1px solid #dcdcdc;
            font-size: 16px;

            > div {
                height: 43px;
                line-height: 43px;
                text-align: center;
                border-right: 1px solid #dcdcdc;
            }

            > div:nth-of-type(1) {
                width: 40%;
            }

            > div:nth-of-type(2) {
                width: 60%;
            }

        }

        > div:last-child {
            border-bottom: 1px solid #dcdcdc;
        }
    }
</style>